<div class="alert alert-success" *ngIf="alertSuccess">
  Folder saved successfully!
</div>
<div class="alert alert-success" *ngIf="alertUpdateSuccess">
  Folder updated successfully!
</div>
<div class="alert alert-danger" *ngIf="alertFailure">
  {{errorMsg}} !
</div>
<div class="alert alert-success" *ngIf="deleteSuccess">
  Deleted successfully!
</div>
<div class="alert alert-danger" *ngIf="timeOutError">
  {{timeoutErrorMessage}}
</div>
<div class="alert alert-danger" *ngIf="errorMsgUploadSave">
  Uploading failed and data will not be saved!
</div>

<div class="common-padding">

  <h4 class="headspace">CHAPTER RESOURCES >> MANAGE FOLDER</h4>
  <form class="admin-font-style" (ngSubmit)="onManageFolderSubmit()" action="" name="manageFolderForm"
    #manageFolderForm="ngForm">
    <div>
      <div class="col-md-6 inlineFlex leftFloat zeroLeftPad" [ngClass]="{'pointerDisable': editAndSave ==true}">
        <label class="col-md-3 zeroLeftPad">Select Site<span class="star"> *</span></label>
        <ng-select [ngClass]="{'disableSection': editAndSave ==true}" placeholder="--Select Site--" class="col-md-8" [items]="siteList" name="siteName"
          bindLabel="siteName" [(ngModel)]="selectedSite" (change)="siteChange($event)" required></ng-select>
      </div>
      <div class="col-md-6 inlineFlex zeroRightPad" [ngClass]="{'pointerDisable': editAndSave ==true}">
        <span class="divide-width"></span>
        <label class="col-md-3">Select BPG <span class="star"> *</span></label>
        <ng-select [ngClass]="{'disableSection': editAndSave ==true}" placeholder="--Select BPG--" class="col-md-8 zeroRightPad" [items]="bpgList" name="bpgName"
          bindLabel="bpgName" [(ngModel)]="selectedBpg" (change)="bpgChange($event)" required></ng-select>
      </div>

      <div class="col-md-6 inlineFlex zeroRightPad">
        <label class="col-md-3 zeroLeftPad" for="folderName">Folder Name<span class="star">*</span></label>
        <input type="text" [maxlength]="50" class="form-control col-md-8 zeroRightPad placeholder" name="folderName"
          id="folderName" placeholder="Folder Name" [(ngModel)]="folderName" required>
      </div>

    </div>
    <div class="top-space text-center col-md-12">

      <button type="submit" *ngIf="!editAndSave" id="submitButton" class="btn btn-danger col-sm-2 col-md-2 style btn-width"
        [disabled]="!manageFolderForm.valid" data-target="#myModal" data-toggle="modal">SAVE</button>
        <button type="submit" *ngIf="editAndSave" id="submitButton" class="btn btn-danger col-sm-2 col-md-2 style btn-width"
        [disabled]="!manageFolderForm.valid" data-target="#myModal" data-toggle="modal">SAVE AND UPDATE</button>
      <span class="preview"></span>
      <button type="button" class="btn btn-danger col-sm-2 col-md-2 style btn-width" data-toggle="modal"
      data-target="#myModal" (click)="resetClick()">RESET</button>
      <span class="preview"></span>
      <button type="button" class="btn btn-danger col-sm-2 col-md-2 style btn-width" data-toggle="modal"
        data-target="#myModal" (click)="cancelClick()">BACK</button>
    </div>

  </form>
  <app-confirmation-modal [PData]="msg1" (emitPass)="this[method](param)" id="2"></app-confirmation-modal>

  <div class="col-md-12  search-div-style">

    <div class="col-md-5 div-bottom">
      <ng-select placeholder="--Select Site--" [items]="siteListSearch" name="siteName" bindLabel="siteName"
        [(ngModel)]="selectedSiteSearch" (change)="siteChangeSearch($event)" required></ng-select>
    </div>
    <div class="col-md-5  div-bottom">
      <ng-select placeholder="--Select BPG--" [items]="bpgListSearch" name="bpgName" bindLabel="bpgName"
        [(ngModel)]="selectedBpgSearch" (change)="bpgChangeSearch($event)"></ng-select>
    </div>

    <div class="col-md-2 div-bottom">

      <button type="button" class="btn btn-danger search-button-style gallery-but"
        (click)="getDocumentsFolderListForSearch()">Search</button>
    </div>
  </div>


  <!--table-->
  <p class="noDataFound text-center" *ngIf="noDataFound"> No data found </p>
  <div class="table-container" *ngIf="tableShow">
    <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}" class="table table-striped" id="tabledemo">
      <thead>
        <tr class="tr-th">
          <th scope="col">Site</th>
          <th scope="col">BPG</th>
          <th scope="col">Folder Name</th>
          <th scope="col">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let data of documentsFolderList | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: numberOfElements },let i = index">
          <td>{{data.siteName}}</td>
          <td>{{data.bpgName}}</td>
          <td>{{data.folderName}}</td>
          <td class="edit-delete-button">
            <a id="edit{{i}}" (click)="updateDocument(data,i)" class="edit-delete"><img src="assets/images/edit.png"
                class="image" title="Edit" alt="Angular Logo"></a>
            <a id="edit{{i}}" (click)="deleteFolderConfirmation(data.folderId)" class="edit-delete"
              data-target="#myModal" data-toggle="modal"><img src="assets/images/delete.png" class="image"
                title="Delete" alt="Angular Logo"></a>
          </td>
        </tr>
      </tbody>
    </table>
    <div id="bpgpagination" *ngIf="numberOfElements > limit" class="pagination-outerdiv">
      <span>Showing {{currentShowingElements}} of {{numberOfElements}} results</span>
      <pagination-controls previousLabel="Prev" nextLabel="Next" (pageChange)="pageChanged($event)">
      </pagination-controls>
    </div>

  </div>
